<div class="padding flex column fix-height">
	<b class="margin-bottom-small">{{ data.title }}</b>

	<form class="date-container">
		<mat-form-field appearance="outline">
			<mat-label>Start Date</mat-label>
			<input matInput name="startDate" [matDatepicker]="startPicker" [(ngModel)]="startDate" />
			<mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
			<mat-datepicker #startPicker></mat-datepicker>
		</mat-form-field>

		<mat-form-field appearance="outline">
			<mat-label>End Date</mat-label>
			<input matInput name="endDate" [matDatepicker]="endPicker" [(ngModel)]="endDate" />
			<mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
			<mat-datepicker #endPicker></mat-datepicker>
		</mat-form-field>
	</form>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<mat-icon>undo</mat-icon>
				Discard
			</button>
			<button [mat-dialog-close]="dates" cdkFocusInitial>
				<mat-icon>check</mat-icon>
				Apply
			</button>
		</div>
	</div>
</div>
